// extracted by mini-css-extract-plugin
export default {"instructorSwiperWrapper":"InstructorCarousel_instructorSwiperWrapper__juD9n","instructorSwiper":"InstructorCarousel_instructorSwiper__TU7c5"};